/* eslint-disable @typescript-eslint/no-explicit-any */
import Skeleton from "react-loading-skeleton";
import FieldglassButton from "components/UI/FieldglassButton";
import { getBadgeFromStatus } from "utils/functions";
import { useTranslation } from "react-i18next";

type HeaderProps = {
  data: {
    name: string;
    fieldglassId: string;
    supplierName?: string;
    supplierCode?: string;
    status: string;
    zIdentifier: string;
    startDate?: string;
    endDate?: string;
  };
  isLoading: boolean;
  type: "worker" | "sow" | "supplier";
};

const Header = ({ data, isLoading, type }: HeaderProps) => {
  const { t } = useTranslation("status");

  return (
    <>
      {isLoading ? (
        <>
          <Skeleton baseColor="#f8f8f8" width="300px" data-cy="skeleton-name" />
          <Skeleton baseColor="#f8f8f8" width="200px" data-cy="skeleton-id" />
        </>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 1rem .5rem 1rem",
            borderBottom: "1px solid #ccc",
          }}
          data-cy="header-container"
        >
          <div
            style={{ display: "flex", flexDirection: "column" }}
            data-cy="header-details"
          >
            <p
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                display: "flex",
                lineHeight: "100%",
                alignItems: "center",
                gap: "8px",
              }}
              data-cy="header-name"
            >
              {data?.name}
              {data?.status &&
                getBadgeFromStatus(data?.status, (text: string) =>
                  t(text, { ns: "status" }),
                )}
            </p>
            <p
              style={{
                fontSize: "16px",
                fontWeight: "bold",
                opacity: 0.9,
              }}
              data-cy="header-fieldglass-id"
            >
              {data?.fieldglassId}
            </p>
            <p style={{ color: "black", opacity: 0.8 }} data-cy="header-period">
              {t("period", { ns: "profile" })} :{" "}
              {data?.startDate ?? t("Without Start Date", { ns: "profile" })} -{" "}
              {data?.endDate ?? t("Without End Date", { ns: "profile" })}
            </p>
            <p style={{ color: "black", opacity: 0.8 }}>
              {data?.supplierName && `${t("Supplier", { ns: "profile" })}: `}
              {data?.supplierName}
              {data?.supplierCode && ` (${data?.supplierCode})`}
            </p>
          </div>

          {data?.zIdentifier && (
            <div
              style={{ display: "flex", gap: "4px" }}
              data-cy="header-button-container"
            >
              <FieldglassButton
                type={type === "worker" ? "workerProfile" : "sowProfile"}
                zIdentifier={data?.zIdentifier}
                data-cy="header-fieldglass-button"
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Header;
